import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/account/profile")({
  head: () => {
    const isEn = typeof window !== "undefined" && localStorage.getItem("saba_lang") === "en";
    return { meta: [{ title: isEn ? "My Profile | BAZZAR 3D" : "ملفي الشخصي | بازار ثرى دى" }] };
  },
  component: lazyRouteComponent(() => import("@/pages-lazy/account-profile")),
});
